import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-chevron--fill-current-color",
  "use": "left-chevron--fill-current-color-usage",
  "viewBox": "0 0 407.436 407.436",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 407.436 407.436\" id=\"left-chevron--fill-current-color\">\n<polygon points=\"315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 \" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-chevron.svg?fill=currentColor
// module id = pCaQ
// module chunks = 1